<script>
	// import BloomLogo from './BloomLogo.svelte';
	import BloomLogoMember from './BloomLogoMember.svelte';
	export let user;
</script>

<!-- {#if !$user}
	<div class="absolute flex text-center inset-y-0 left-20 lg:left-10 xl:left-14">
		<div class="flex flex-shrink-0 items-center ml-2 mr-auto mt-1 sm:mt-2 lg:mt-3">
			<a data-sveltekit-preload-data="hover" href="/">
				<BloomLogo />
			</a>
		</div>
	</div>
{:else} -->
<div
	class={`absolute translate-y-0 -ml-5 md:ml-0 lg:translate-y-1 md:left-1/2 transform md:-translate-x-1/2 ${user ? 'lg:left-auto lg:flex lg:transform-none' : 'lg:left-auto lg:flex '} lg:transform-none lg:relative lg:justify-center lg:items-center`}
>
	<div class="flex flex-shrink-0 items-center ml-2 lg:-ml-4 mr-auto scale-50 md:scale-75 xl:mt-2">
		<a data-sveltekit-preload-data="hover" href="/home" aria-label="Bloom Network Home">
			<BloomLogoMember />
		</a>
	</div>
</div>
<!-- {/if} -->
